<template>
  <div>
    <v-dialog v-model="mostra" width="600" persistent>
      <v-toolbar color="primary" dense class="white--text">
        <v-toolbar-title>Ping</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small @click="SendPing()"
          ><v-icon color="success">mdi-send</v-icon></v-btn
        >
        <v-spacer></v-spacer>
        <v-btn small @click="chiudiDialog()"
          ><v-icon color="red">mdi-close</v-icon></v-btn
        >
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field dense v-model="ip" label="IP Address">
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  dense
                  type="number"
                  v-model.number="timeout"
                  :min="0"
                  label="Timeout (ms)"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <span v-if="ping_response != null">Ping response:</span>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>
<script>
import validIp from "../Anagrafica Quickconnext Box/Dialog Rete/ipformat.js";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
export default {
  components: {
    SnackbarQV,
  },
  props: {},
  data: () => ({
    ip: "",
    timeout: 1000,
    NETWORK: null,
    ping_response: null,
    mostra: false,
    id_dispositivo: null,
  }),
  watch: {},
  methods: {
    chiudiDialog() {
      this.mostra = false;
      this.ip = null;
      this.timeout = 1000;
    },
    SendPing() {
      let that = this;
      let isValid = validIp.checkIpFormat(this.ip);
      if (isValid) {
        const request = {
          controller: "quickconnext",
          endpoint : 'connext',
          response: { parse: false },
          showdialog:false,
          body: {
            action: "pingdevice",
            token: localStorage.user_token,
            ip: this.ip,
            timeout: this.timeout,
            id_dispositivo: this.id_dispositivo,
          },
          method: "PUT",
          on: {
            load: function (response) {
              console.log("res", response);
              that.$refs.SnackbarQV.print("success", response);
            },
            error: function (err) {
              console.log("err", err);
              that.$refs.SnackbarQV.print("error", err.srcElement.responseText);
            },
          },
        };
        this.NETWORK.AjaxRequest(request);
      } else {
        this.$refs.SnackbarQV.print(
          "error",
          "L'indirizzo IP inserito non è valido."
        );
      }
    },
  },
  mounted() {
    this.NETWORK = this.$store.state.Network;
  },
};
</script>
